<template>
    <div>
        <div class="rule-detail" v-if="popups.ruleDetail.show">
           <span class="rule-detail__sections" v-if="isRemovedPage && rule.sections_before && rule.sections_before.length">
                <template v-for="(section, index) in rule.sections_before">
                    <span v-if="index > 0" class="text-color-grey ml4 mr4">/</span>
                    <span :class="{ 'line-through': section.removed }">{{ section.name }}</span>
                </template>
            </span>
            <div class="rule-detail__info" v-if="isRemovedPage">
                <tooltip
                     :direction="'bottom-left-direction'"
                     :add-class-wrap="'tooltip-log'"
                     :isBtnClose="false"
                     :add-style="{width: 360 + 'px'}"
                     @tooltipshow="logActive = true"
                     @tooltipclose="logActive = false">
                    <span slot="tooltipBtn" class="i i-info4 mr4" :class="{active: logActive}">
                    </span>

                    <div slot="tooltipContent">
                        <div class="text-size-s text-bold">
                            История
                        </div>
                        <div class="mt8" v-for="row in history">
                            <span>{{ row.event }} {{ row.date }}, {{ row.time }}</span>
                            <span class="ml4 mr4">|</span>
                            <span>{{ row.user }}</span>
                        </div>
                    </div>
                </tooltip>
                <span>{{ historyLast.event }} {{ historyLast.date }}, {{ historyLast.time }}</span>
                <span class="ml4 mr4">|</span>
                <span> {{ historyLast.user }}</span>
            </div>
            <div class="rule-name">
                <span v-html="rule.name"></span>
                <div v-if="this.isSearch" class="df">
                    <template v-if="rule.ruleType">
                        <tooltip
                                :is-btn-close="false"
                                :add-style="{width: 424 + 'px'}"
                                :direction="'bottom-right-direction'">
                        <span slot="tooltipBtn">
                            <div class="rule-type" :class="ruleColor(rule.ruleType)">
                                {{ ruleTypeName(rule.ruleType) }}
                            </div>
                        </span>

                            <div slot="tooltipContent">
                                <div class="rule-types">
                                    <div class="text-size-l text-bold mb12">
                                        Типы правил
                                    </div>
                                    <div class="item" :class="{'active': rule.ruleType == 1}">
                                        <div class="rule-type --blank">
                                            заготовка
                                        </div>
                                        <div class="text-italic text-color-grey text-size-xs">
                                            Заметка, которая создана обычным пользователем.
                                        </div>
                                    </div>
                                    <div class="item" :class="{'active': rule.ruleType == 2}">
                                        <div class="rule-type --draft">
                                            черновик
                                        </div>
                                        <div class="text-italic text-color-grey text-size-xs">
                                            Правило, над которым работает технический писатель.
                                        </div>
                                    </div>
                                    <div class="item" :class="{'active': rule.ruleType == 4}">
                                        <div class="rule-type">
                                            правило
                                        </div>
                                        <div class="text-italic text-color-grey text-size-xs">
                                            Готовый и отредактированный документ.
                                        </div>
                                    </div>
                                    <div class="item" :class="{'active': rule.ruleType == 5}">
                                        <div class="rule-type --archive">
                                            архивное
                                        </div>
                                        <div class="text-italic text-color-grey text-size-xs">
                                            Скрытое от общего доступа правило
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tooltip>
                    </template>
                    <div class="number ml4">
                        #{{ rule.id }}
                    </div>
                    <a class="link ml24" target="_blank" :href="'/rules/sid'+rule.sectionTop+'/sub'+rule.section+'/rule'+rule.id+'/'"><span class="i i-link3"></span></a>
                </div>
            </div>
            <div class="txt" @click="handleOffset($event, rule)" :class="{'zoomed': tumblers.zoom.value}">
                <dynamic-html :html="rule.text" ></dynamic-html>
            </div>
        </div>
		<rule-history v-if="!isRemovedPage && popups.ruleDetail.show && rule.id" :item="rule"/>
    </div>
</template>

<script>


import {mapState} from 'vuex'
import Popup from '@/components/modal/Popup.vue';
import Tooltip from '@/components/Tooltip.vue';
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import DynamicHtml from '@/components/moderator/Rules/DynamicHtml.vue';
import VueFooter from '@/components/VueFooter.vue';
import RuleHistory from '@/components/moderator/Rules/RuleHistory.vue';


    export default {
        name: "RuleDetail",
        components: {
            Hooper,
            Slide,
            DynamicHtml,
            HooperNavigation,
            Tooltip,
            Popup,
            VueFooter,
            RuleHistory,
        },
        props: {
            show: {
                default: function () {
                    return false
                }
            },

        },
        data: function () {
            return {
                currentSlide: 1,
                currentSlidePrev: 1,
                isShowedViewer: false,
                secondSections: [],
                hoveredPrev: false,
                hoveredNext: false,
                textElem: '',
                offsetX: 0,
                stringNum: '',
                scrollTop: 0,
                logActive: false,
				makeZoom: false,
                typesOptions: {
                    0:{ name: 'все'},
                    1: {name: 'заготовка'},
                    2: {name: 'черновик'},
                    4: {name: 'правило'},
                    5: {name: 'архивное'},
                },
            }
        },
        mounted: function () {
        },
        watch: {

        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.editItem,
                sections: state => state.rules.sections,
                selectSections: state => state.rules.selectSections,
                topSections: state => state.rules.topSections,
                tumblers: state => state.rules.tumblers,
                notifyData: state => state.rules.notifyData,
                isSearch: state => state.rules.isSearch,
                rule: state => state.rules.openedRule,
                isLoadNotifyData: state => state.rules.isLoadNotifyData,
                user: state => state.users.user,
            }),
            isRemovedPage (){
                return this.$route.name == 'rules-removed';
            },
            history() {
                let history = [];

                if (typeof this.rule.history !== 'undefined') {
                    history = this.rule.history;
                }

                return history;
            },
            historyLast() {
                let history = [];

                if (typeof this.rule.history !== 'undefined' && this.rule.history.length) {
                    history = this.rule.history.slice(-1).pop();
                }

                return history;
            },
        },

        methods: {
            closeSearch() {
                this.$store.commit('rules/setIsSearch', false);
                this.$store.commit('popups/close', { name: this.popups.ruleDetail.name });
            },
            handleOffset(e, item){
                let hHeight = document.querySelector('h1') ? document.querySelector('h1').clientHeight : 0;
                this.scrollTop = e.pageY - hHeight - 100;
                this.currentItem = item;

                this.offsetX = window.getSelection().getRangeAt(0).startOffset;
                if(e.altKey){
                    e.preventDefault();

                    const range = document.caretRangeFromPoint(e.clientX, e.clientY);
                    if (!range) return;

                    const { startContainer, startOffset } = range;

                    const path = [];
                    let node = startContainer;
                    while (node && node !== document.querySelector('.js-rule-content')) {
                    const parent = node.parentNode;
                    const index = Array.from(parent.childNodes).indexOf(node);
                        path.unshift(index);
                        node = parent;
                    }


                    if((this.getRights(item) === 'W'  && !item.finally)  && !this.isRemovedPage || (this.user.access_rights.is_owner || this.getRights(item) === 'C') && !this.isRemovedPage){
                        this.$store.commit('rules/setUseShortcut', true);
                        this.$store.commit('rules/setLoadEditRule', true);
                        this.$store.commit('rules/setCursorPositionObj', {
                            scrollTop: this.scrollTop,
                            offsetX: startOffset,
                            path: path,

                        });
                        if (this.isSearch) {
                            setTimeout(()=>{
                                this.closeSearch();
                            }, 300);
                        }
                        this.openAddRule(item);
                    }
                }
            },
            openAddRule: function (item) {

              //очистка от <span class="query"></span>
              let tmpDiv = document.createElement("div");
              tmpDiv.innerHTML = item.name;
              item.name = tmpDiv.innerText;

              if(!item.isCheckEdit){
                    let timeout = setTimeout(()=>{
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: true});
                    },500)

                    this.$store.commit('rules/setLoadItems', true);
                    this.$store.dispatch('rules/checkEditItem',item).then((result)=>{
                        if(result.status){
                            this.$store.commit('rules/setLoadItems', false);
                            this.$store.commit('popups/open', {name: this.popups.editDisabled.name});
                        } else {
                            if(this.$route.name == 'rules-removed'){
                                this.$router.push('/sid'+item.sectionTop+'/sub'+item.section+'/');
                            }

                            this.$store.dispatch('rules/setEditItem',item).then(()=>{
                              this.$store.commit('rules/setIsEdit', true);
                              this.$store.dispatch('popups/open', {name: this.popups.addRule.name});
                            })
                            document.documentElement.scrollTop = 0;

                        }
                        clearTimeout(timeout);
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: false});
                    },()=>{
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: false});
                    }).catch(()=>{
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: false});
                    })
                }

            },
            getRights(item) {
              let section = this.topSections.find(sect => sect.id === item.sectionTop),
                  rights = 'R';

              if (typeof(section) !== 'undefined') {
                rights = section.rights;
              }

              return rights;
            },
            goToRule(link){
                this.$store.commit('rules/setIsSearch', false);
                this.$router.push(link);
            },
            ruleColor(i) {
                let classesColor = {
                        0: '--blank',
                        1: '--blank',
                        2: '--draft',
                        3: '--rule',
                        4: '--rule',
                        5: '--archive',
                        6: '--blank',
                    },
                    selected = 0;

                if (typeof classesColor[i] !== 'undefined') {
                    selected = classesColor[i];
                }

                return selected;
            },
            ruleTypeName(i) {
                let name = '';
                if (typeof this.typesOptions[i] !== 'undefined') {
                    name = this.typesOptions[i]['name'];
                }

                return name;
            },
        },
    }
</script>

<style>

</style>
